import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Container, Box, Typography, Button, Switch, FormControlLabel, TextField, CircularProgress } from '@mui/material';
import { useAutoRenewal } from '../../hooks/useAutoRenewal';
import { validateSettings } from '../../utils/renewalValidation';
import t from '../../utils/renewalsTranslations';

export default function AutoRenewalSettings() {
  const { id: policyId } = useParams();
  const navigate = useNavigate();
  const { settings, loading, error, update } = useAutoRenewal(policyId);
  const [saving, setSaving] = useState(false);
  const [form, setForm] = useState({ is_enabled: false, prefer_current_insurer: true, max_price_increase_percentage: 10, notify_before_days: 30 });
  const [fieldErrors, setFieldErrors] = useState({});

  useEffect(() => {
    if (settings) setForm({ is_enabled: !!settings.is_enabled, prefer_current_insurer: settings.prefer_current_insurer !== false, max_price_increase_percentage: settings.max_price_increase_percentage ?? 10, notify_before_days: settings.notify_before_days ?? 30 });
  }, [settings]);

  const handleSave = async () => {
    setSaving(true);
    try { await update(form); } catch (e) { console.warn(e); }
    finally { setSaving(false); }
  };

  if (loading) return <Container sx={{ py: 3 }}><CircularProgress /></Container>;
  if (error) return <Container sx={{ py: 3 }}><Typography color="error">{error}</Typography></Container>;

  return (
    <Container maxWidth="sm" sx={{ py: 3 }}>
      <Typography variant="h6" sx={{ mb: 2 }}>{t('renewals.settings.title')}</Typography>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
        <FormControlLabel control={<Switch checked={form.is_enabled} onChange={(e) => setForm((f) => ({ ...f, is_enabled: e.target.checked }))} />} label={t('renewals.settings.enabled')} />
        <FormControlLabel control={<Switch checked={form.prefer_current_insurer} onChange={(e) => setForm((f) => ({ ...f, prefer_current_insurer: e.target.checked }))} />} label={t('renewals.settings.preferCurrent')} />
        <TextField type="number" label={t('renewals.settings.maxIncrease')} value={form.max_price_increase_percentage} onChange={(e) => setForm((f) => ({ ...f, max_price_increase_percentage: Number(e.target.value) || 10 }))} inputProps={{ min: 0, max: 100 }} error={!!fieldErrors.max_price_increase_percentage} helperText={fieldErrors.max_price_increase_percentage} error={!!fieldErrors.max_price_increase_percentage} helperText={fieldErrors.max_price_increase_percentage} />
        <TextField type="number" label={t('renewals.settings.notifyBefore')} value={form.notify_before_days} onChange={(e) => setForm((f) => ({ ...f, notify_before_days: Number(e.target.value) || 30 }))} inputProps={{ min: 7, max: 90 }} error={!!fieldErrors.notify_before_days} helperText={fieldErrors.notify_before_days} />
        <Box sx={{ display: 'flex', gap: 1 }}>
          <Button variant="contained" onClick={handleSave} disabled={saving}>{saving ? <CircularProgress size={24} /> : t('renewals.settings.save')}</Button>
          <Button onClick={() => navigate(`/renewals/${policyId}`)}>{t('renewals.settings.back')}</Button>
        </Box>
      </Box>
    </Container>
  );
}
